import { Outlet } from "react-router"

export const Bookings = () => {
    return <Outlet />
}
